import { getProducts } from "../../utils/api";
import { SET_PORTAL_API } from "./portal_actions";
import { TITLE_ERROR } from "../../utils/constants";
import { CATEGORIES_ADD_ROUTES } from "./categories_actions";
import { getArrayForRoutes } from "../../utils/util_functions";

export const GET_PRODUCTS_REQUEST = 'GET_PRODUCTS_REQUEST';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAILED = 'GET_PRODUCTS_FAILED';

export const getProductsThunk = () => {
  return async (dispatch) => {
    getProducts()
      .then(products => {
        dispatch({
          type: GET_PRODUCTS_SUCCESS,
          products
        });
        dispatch({
          type: CATEGORIES_ADD_ROUTES,
          routes: getArrayForRoutes(products)
        });
      })
      .catch(error => {
        dispatch({ type: GET_PRODUCTS_FAILED });
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      });
  }
}
